/**
 * Lightweight TTL-aware sessionStorage cache for API responses.
 * Prevents duplicate network requests across components and page navigations.
 */

const CACHE_VERSION = 'bj_c1';

export const TTL = {
  logo:    24 * 60 * 60 * 1000,  // 24 hours  – logo rarely changes
  public:   5 * 60 * 1000,       // 5 minutes – sliders, promos, general
  private:     30 * 1000,        // 30 seconds – balance, transactions
};

function cacheKey(name) {
  return `${CACHE_VERSION}:${name}`;
}

/**
 * Read a cached value. Returns null if missing or expired.
 */
export function getCached(name) {
  try {
    const raw = sessionStorage.getItem(cacheKey(name));
    if (!raw) return null;
    const { data, expiry } = JSON.parse(raw);
    if (Date.now() > expiry) {
      sessionStorage.removeItem(cacheKey(name));
      return null;
    }
    return data;
  } catch {
    return null;
  }
}

/**
 * Store a value in the cache with a TTL.
 */
export function setCached(name, data, ttlMs) {
  try {
    sessionStorage.setItem(cacheKey(name), JSON.stringify({
      data,
      expiry: Date.now() + ttlMs,
    }));
  } catch {
    // sessionStorage quota exceeded — skip silently
  }
}

/**
 * Remove a cached entry (use after mutations that invalidate cached data).
 */
export function invalidateCache(name) {
  try { sessionStorage.removeItem(cacheKey(name)); } catch { /* ignore */ }
}
